const PrevIcon = () => (
  <svg
    width="9"
    height="14"
    viewBox="0 0 9 14"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      strokeWidth="2"
      d="M8 1L2 7l6 6"
      stroke="#0F58D6"
      fill="none"
      fillRule="evenodd"
    />
  </svg>
);

const NextIcon = () => (
  <svg
    width="9"
    height="14"
    viewBox="0 0 9 14"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M1 13l6-6-6-6"
      fillRule="nonzero"
      stroke="#0F58D6"
      strokeWidth="2"
      fill="none"
    />
  </svg>
);

export { PrevIcon, NextIcon };
